module.exports = __webpack_public_path__ + "static/media/escuela_enfermeria.ce9e0a57.jpg";